module.exports = __webpack_public_path__ + "img/inform-no.ec069fcb.svg";